
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
// import AsideBar from './AsideBar'

import './info-call.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
import ComplianceHits from './ComplianceHits'
import ComplianceImprovents from './ComplianceImprovents'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function CallReportResume(props) {
    const { data } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(data)
    const [positive, setPositive] = useState(0)
    const [neutro, setNeutro] = useState(0)
    const [negative, setNegative] = useState(0)
    const [total, setTotal] = useState(0)
    const [minimumPassingScore, setMinimumPassingScore] = useState(0);
    const { t } = useTranslate();

    useEffect(() => {
        setCall(data)
        setMinimumPassingScore(JSON.parse(localStorage.getItem('report_project_selected')).minimum_passing_score);

        let positive_count = 0
        let negative_count = 0
        let neutro_count = 0
        let total_sum = 0 
        call?.sentiment.map((item, idex) => {
            if (item.polarity == 'POS') {
                positive_count = positive_count + 1
                total_sum = total_sum + 1
            }
            else if (item.polarity == 'NEU') {
                neutro_count = neutro_count  + 1
                total_sum = total_sum + 0
            }
            else if (item.polarity == 'NEG') {
                negative_count = negative_count  + 1
                total_sum = total_sum - 1
            }
        })
        setNegative(negative_count)
        setPositive(positive_count)
        setNeutro(neutro_count)
        const score = (total_sum/ (call?.sentiment?.length || 1 ))
        setTotal(((score + 1) / 2).toFixed(2))
    }, [data])

    return (
        <>
            <div className="info-call w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}  >
                <div className="info-call-item header">
                    <div className="d-flex flex-column">
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <h4 style={{fontWeight: "bold",color: "#4d4d4d", fontSize: 16}}>{t('common.scoreMayus')}:</h4>
                            <div className="porcentaje ml-3" 
                                style={{color: '#0B5FA3', fontSize: 20, fontWeight: "bold", whiteSpace: 'nowrap'}}>
                                {Number((call.qualification * 100).toFixed(1))}% 
                            </div>
                        </div>
                        <div style={{fontSize: 12}}>{minimumPassingScore}{t('reports.percentageMinimun')}</div>
                        <div style={{marginTop: 10, color: 'white'}}>
                            {Number((Number((call?.qualification || 0)) * 100).toFixed(1)) < Number(minimumPassingScore) 
                                ? <div style={{background: 'red', padding: 5, borderRadius: 25, textAlign: 'center'}}>{t('reports.failed')}</div> 
                                : <div style={{background: 'green', padding: 5, borderRadius: 25, textAlign: 'center'}}>{t('reports.approved')}</div>}
                        </div>
                    </div>

                    <div style={{ padding: 10, textTransform: 'uppercase', fontSize: 14, color: "#0B5FA3" }}>
                        {/*<h4 style={{ fontSize: 18, fontWeight: "bold",color: "#0B5FA3" }}>Bot sentiment result:</h4>*/}
                        <div className="d-flex flex-row align-items-center"
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}} >
                            <div class="m-1" style={{ fontWeight: "bold"}}>{t('reports.positive')}:</div>
                            <div style={{ marginLeft: 3 }}>{positive}</div>
                        </div>
                        <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div style={{ fontWeight: "bold" }}>{t('reports.neutral')}:</div>
                            <div style={{ marginLeft: 3 }}>{neutro}</div>
                        </div>
                        <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div style={{ fontWeight: "bold" }}>{t('reports.negative')}:</div>
                            <div style={{ marginLeft: 3 }}>{negative}</div>
                        </div>
                        <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <div class="m-1" style={{ fontWeight: "bold" }}>{t('reports.sentiment')}:</div>
                            <div style={{ marginLeft: 3, letterSpacing: 1 }}>{(total * 100).toFixed(2)}%</div>
                        </div>
                    </div>

                    <div className="time-metrics-container">
                        <div className="time-metric-box">
                            <h4 className='font-bold text-[#0B5FA3] uppercase' style={{fontSize: 13}}>{t('reports.totalTimeCall')}</h4>
                            <div className='text-[#0B5FA3] w-100 text-bold' style={{textAlign: 'right', fontSize: 24}}>
                                {call.time_call}
                            </div>
                        </div>
                        <div className="time-metric-box">
                            <h4 className='font-bold text-[#0B5FA3] uppercase' style={{fontSize: 13}}>{t('reports.timesInHold')}</h4>
                            <div className='text-[#0B5FA3] w-100 text-bold' style={{textAlign: 'right', fontSize: 24}}>
                                {call?.time_hold || 0}
                            </div>
                        </div>
                        <div className="time-metric-box">
                            <h4 className='font-bold text-[#0B5FA3] uppercase' style={{fontSize: 13}}>{t('reports.totalHoldTime')}</h4>
                            <div className='text-[#0B5FA3] w-100 text-bold' style={{textAlign: 'right', fontSize: 24}}>
                                {call?.second_hold || 0}
                            </div>
                        </div>
                    </div>

                    
                </div>
                {(call?.short_conversation || 0) == 1 &&
                <div class="info-call-item body">
                    <h6 className="font-bold">
                        {t('reports.shortConversation')}
                    </h6>
                </div>}
                {(call?.short_conversation || 0) == 0 &&
                <div class="info-call-item body">
                    <div>
                        <h2 className="font-bold  text-[#0B5FA3] text-[24px]" >{t('reports.hits')}</h2>
                        <div class="container-call-info">
                            <ComplianceHits data={call} />
                        </div>
                    </div>
                    <div style={{ paddingRight: 15}}>
                        <h2 className="font-bold  text-[#0B5FA3] text-[24px]" >{t('reports.improvements')}</h2>
                        <div class="container-call-info"   >
                            <ComplianceImprovents data={call} />
                        </div>
                    </div>
                </div>}
            </div>
        </>


    )
}
